import { render, staticRenderFns } from "./IconSvgUsers.vue?vue&type=template&id=64a89115&scoped=true&"
import script from "./IconSvgUsers.vue?vue&type=script&lang=js&"
export * from "./IconSvgUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a89115",
  null
  
)

export default component.exports